import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import moment, { months } from "moment";
import StatusModel from "./statusupdate";
import { toast, ToastContainer } from "react-toastify";
import {CustomInvoice } from "./getCustomInvoicejsx";
import { ShowStations } from "../../campaign/ShowStations";

class CampaignListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      dsaConf: "",
      page: 1,
      limit: 10,
      totalRecords: 0,
      selectedCampaigns: [],
      selectedMonths: [],
      StatusModel: false,
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      statusMessage: "",
      totalCamp: 0,
      grade: 0,
      customInVoiceNo:"",
      showCustomInvoiceNoPopup:false,
      showstationlist: false,
      currentStations: [],
    };
  }

  hideshowstations = (e) => {
    this.setState({ showstationlist: !this.state.showstationlist });
  };

  //Get Campaign Data
  componentDidMount = () => {
    let { page } = this.state;
    this.getCampignsData(page);
  };

  //Fetching Campign Data from backend
  getCampignsData = async (page) => {
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      invoicenotgenerated: true,
      withIncentives: true
      //   page
    };
    let data1 = await axiosInstnace.post(
      endPoints.getcampaignsbasedondsa,
      data
    );
    let config = await axiosInstnace.get(endPoints.getdsaconfig);
    config = config.data.data[0];
    let {
      result,
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp,
    } = data1.data.data;
    for (const camp of result) {
      camp.month = moment(parseInt(camp.createdAt)).get("M");
    }
    this.setState({
      campaignsData: result,
      dsaConf: config,
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      grade,
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };
  handlestatuspage = () => {
    this.setState({
      StatusModel: !this.state.StatusModel,
    });
    window.location.reload(true);
  };

  getCustomInvoice = (e)=>{
    this.setState({
      customInVoiceNo: e.target.value
    })
  }

  selectCampaigns = (e, month) => {
    let { selectedCampaigns, selectedMonths } = this.state;
    if (
      (month === 3 && selectedMonths.includes(2)) ||
      (month === 2 && selectedMonths.includes(3))
    ) {
      toast.error(
        "Different Financial Year can't be clubbed for invoice generation",
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: false,
          toastId: "1",
        }
      );
      return
    }
    let monthCamps = this.state.campaignsData.filter((e) => {
      return e.month === month;
    });
    monthCamps = monthCamps.map((e) => {
      return e._id;
    });
    if (e.currentTarget.checked) {
      selectedCampaigns = [...selectedCampaigns, ...monthCamps];
      selectedMonths.push(month);
      if(monthCamps.length > 1){
      toast.success(
        "All the Campaigns in that month are added for invoice generation",
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose:3000,
          hideProgressBar: true,
          toastId: "1",
        }
      );}
    } else {
      selectedCampaigns = selectedCampaigns.filter((el) => {
        return !monthCamps.includes(el);
      });
      selectedMonths = selectedMonths.filter((e) => e !== month);
      if(monthCamps.length > 1){
      toast.success(
        "All the Campaigns in that month are removed for invoice generation",
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
          autoClose:3000
        }
      );}
    }
    this.setState({
      selectedCampaigns,
      selectedMonths
    });
  };
  closeCustomInvoicePopup = ()=>{
    this.setState({
      showCustomInvoiceNoPopup: false
    })
  }
  generateInvoice = async () => {
    this.setState({
      showCustomInvoiceNoPopup: false
    })
    let amount = this.state.campaignsData.reduce((amount, campaign) => {
      if (this.state.selectedCampaigns.includes(campaign._id)) {
        return amount + campaign.incentiveAmount;
      } else {
        return amount;
      }
    }, 0);
    let data = {
      date: moment().valueOf(),
      months: this.state.selectedMonths,
      generatedby: this.state.salesUserInfo.email,
      campaigns: this.state.selectedCampaigns,
      amount,
      gst: {
        igst: 0,
        cgst: 0,
        sgst: 0,
      },
      status: "generated",
      customInvoiceNoRequested: this.state.customInVoiceNo
    };
    if (this.state.salesUserInfo.state === this.state.dsaConf.baseState) {
      data.gst.cgst = (amount * this.state.dsaConf.cgst) / 100;
      data.gst.sgst = (amount * this.state.dsaConf.sgst) / 100;
    } else {
      data.gst.igst = (amount * this.state.dsaConf.igst) / 100;
    }
    console.log(data);
    let status = await axiosInstnace.post(endPoints.generateinvoice, data);
    let localOpenedWindowRef = undefined;
    
    if (
      status.data.message === "Invoice Generated" &&
      status.data.code === 200
    ) {
      if(status.data.signurllink){
        localOpenedWindowRef = window.open(status.data.signurllink, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=800');
      }

      window.onmessage = function(e) {
        if(e.data == 'success'){
          localOpenedWindowRef.close();
          window.location.reload();
        }
      }
      
      this.setState({
        StatusModel: true,
        statusMessage:
          'Invoice has been generated successfully. Sign invoice by following process given in popup or Please download manually, print, and have the same signed by the authorized signatory, and post signature please have the same sent across to us as per the details given under clause 5 of the Incentive T&C page.  Thank you',
      });
    }
    // window.location.reload(true);
  };

  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                {campaignsData && campaignsData.length > 0 ? (
                  <div className={`camp_wrapper`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">
                        Invoice Generation
                      </h2>
                      <div className="camp_right">
                        {this.state.selectedCampaigns.length > 0 && (
                          <div className="create_camp_btn">
                            <button onClick={(e)=>{
                              this.setState({
                                showCustomInvoiceNoPopup: true
                              })
                            }}>
                              GENERATE INVOICE
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="camp_listing_wrapper">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>S.No</th>
                            <th>Campaign ID</th>
                            <th>Campaign Name</th>
                            <th>Campaign Payment Date</th>
                            <th>Station</th>
                            <th>
                              Price{" "}
                              <img
                                src="../../assets/images/rupee-indian.svg"
                                className="camp_rupee"
                              />
                            </th>
                            <th>Incentive (%)</th>
                            <th>
                              Incentive Amount
                              <img
                                src="../../assets/images/rupee-indian.svg"
                                className="camp_rupee"
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaignsData.map((campaign, index) => {
                            indexNum++;
                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    onClick={(e) => {
                                      this.selectCampaigns(e, campaign.month);
                                    }}
                                    checked={
                                      this.state.selectedCampaigns.includes(
                                        campaign._id
                                      )
                                        ? true
                                        : false
                                    }
                                  />
                                </td>
                                <td>{indexNum}</td>
                                <td>{campaign._id}</td>
                                <td>{campaign.name}</td>
                                {campaign.bigFmAudio === "false" &&
                                  campaign.paymentdates &&
                                  campaign.paymentdates.payId && (
                                    <td>
                                      {moment(
                                        parseInt(campaign.paymentdates.payId)
                                      ).format("DD MMM YYYY")}
                                    </td>
                                  )}
                                {campaign.bigFmAudio === "true" &&
                                  campaign.paymentdates &&
                                  campaign.paymentdates.payId_1 && (
                                    <td>
                                      {moment(
                                        parseInt(campaign.paymentdates.payId_1)
                                      ).format("DD MMM YYYY")}
                                    </td>
                                  )}
                                {!campaign.paymentdates && (
                                  <td>
                                    {moment(campaign.createdAt).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                )}
                                <td> {campaign.station.includes(",") ? (
                                      <a
                                        onClick={(e) => {
                                          this.setState({
                                            currentStations: campaign.station.split(
                                              ","
                                            ),
                                            showstationlist: true,
                                          });
                                        }}
                                      >
                                        Multiple (
                                        {campaign.station.split(",").length})
                                      </a>
                                    ) : (
                                      campaign.station
                                    )}</td>
                                <td>{campaign.amount - campaign.audioCost - campaign.couponDiscount}</td>
                                <td>{campaign.incentive}</td>
                                <td>
                                  {campaign.incentiveAmount &&
                                    campaign.incentiveAmount.toFixed(2)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                        {totalRecords >= 10 && (
                          <Pagination
                            getAllData={this.getCampignsData}
                            totalRecords={totalRecords}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`bookcampaign`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>
                    <div className="book_camp_para">
                      <p>It seems like you don't have any invoice's yet</p>
                    </div>
                    {/* <div className="book_camp_btn"><button onClick={() => {
                      window.location.href = '/package'
                    }}>BOOK CAMPAIGNS</button></div> */}
                  </div>
                )}
                {this.state.StatusModel && (
                  <StatusModel
                    hide={this.handlestatuspage}
                    isShowing={true}
                    message={this.state.statusMessage}
                  />
                )}
       
              </div>
            </div>
                {this.state.showCustomInvoiceNoPopup && 
                <CustomInvoice  
                okButtonShow={true}
                closeAction={this.closeCustomInvoicePopup}
                okButtonText="Generate Invoice"
                okAction={this.generateInvoice}
                changeInvoiceNo={this.getCustomInvoice}
                msg="If you want to maintain and use existing series of invoice number(As a GST Compliance), please enter next usable invoice number of your existing series. If it's ok to assign autogenerated invoice number please leave it blank."
    />}
          </div>
          <ToastContainer />
        </div>
        {this.state.showstationlist && (
          <ShowStations
            stations={this.state.currentStations}
            closeAction={this.hideshowstations}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CampaignListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/invoicedetails.jsx